import { type Product, PRODUCTS } from "@/constants/products";

/**
 * Products the user can switch to.
 * @returns all configured products
 */
export const getAvailableProducts = (): Product[] => [...PRODUCTS];
